export const ActionsBrandList = {
	GET_BRAND_LIST: "get_brand_list",
	LOAD_GET_BRAND_LIST: "load_get_brand_list",
	RES_GET_BRAND_LIST: "res_get_brand_list",
	ERR_GET_BRAND_LIST: "err_get_brand_list",
	HYDRATE: "HYDRATE",
};

export function failureBrandList(err) {

	return {
		type: ActionsBrandList.ERR_GET_BRAND_LIST,
		err,
	};

}

export function loadBrandList(params = {}) {

	return {
		type: ActionsBrandList.GET_BRAND_LIST,
		...params,
	};

}

export function loadGetBrandList(params = {}) {

	return {
		type: ActionsBrandList.LOAD_GET_BRAND_LIST,
		...params,
	};

}

export function loadBrandListSuccess(data) {

	return {
		type: ActionsBrandList.RES_GET_BRAND_LIST,
		data,
	};

}
